import styled, { device, color } from '@styled'

export const SectionWrapper = styled.section`
  padding-block-start: 60px;
  padding-block-end: 50px;
  ${device.medium} {
    padding-block-start: 80px;
    padding-block-end: 70px;
  }
  ${device.large} {
    padding-block-start: 100px;
    padding-block-end: 90px;
  }
  ${color}
`

export const StyledText = styled.div`
  margin-block-start: 15px;
  margin-block-end: 25px;
  font-size: 18px;
  margin-inline-start: 34px;
  margin-inline-end: 34px;
  b {
    font-weight: 700;
  }
`
